import { graphql } from "react-relay";

export const teamPickerFragments = {
  userTeams: graphql`
    fragment TeamPicker_userTeams on TeamList {
      list {
        teamId
        teamName
      }
    }
  `,
};
